import BeenhereIcon from "@mui/icons-material/Beenhere";
import EditIcon from "@mui/icons-material/Edit";
import LocalActivityIcon from "@mui/icons-material/LocalActivity";
import LocalMallIcon from "@mui/icons-material/LocalMall";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import SyncAltIcon from "@mui/icons-material/SyncAlt";
import {
  Box,
  Button,
  Grid,
  Grid2,
  Paper,
  Typography
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import useMediaQuery from "@mui/material/useMediaQuery";
import Axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import consts from "../../constant";
import Header from "../Header/Header";
import "./Dashboard.css";

const drawerWidth = 260;
const Dashboard = () => {
  let navigate = useNavigate();
  const [user, setUsers] = useState([]);
  const [userCount, setUserCount] = useState(0);
  const [limit, setLimit] = useState(5);
  const [page, setPage] = useState(1);
  const [totalPageCount, settotalPageCount] = useState(0);

  const [assetCount, setassetCount] = useState(0);
  const [pairsCount, setPairsCount] = useState(0);

  const theme = useTheme();
  const lg = useMediaQuery(theme.breakpoints.up("lg"));


  const [kycCount, setKycCount] = useState([]);

  const getKycCount = async () => {
    try {
      const token = localStorage.getItem("adminToken");

      if (!token) {
        console.warn("No authentication token found. Redirecting...");
        navigate(`${consts.route + '/login'}`);
        return;
      }

      const { data } = await Axios.post(
        `${consts.BackendUrl}/admin/getkyclist?limit=${limit}&page=${page}`,
        { type: "pending" },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (data?.success) {
        console.log(data?.result, "KYC Data");
        setKycCount(data?.result?.docs);
      }
    } catch (error) {
      console.error("KYC error:", error);
    }
  };

  useEffect(() => {
    getKycCount();
  }, []);


  const [dashboardData, setDashboardData] = useState({});

  const dashboardCount = async () => {
    try {
      const token = localStorage.getItem("adminToken");
      if (!token) {
        throw new Error("No authorization token found. Please log in.");
      }

      const { data } = await Axios.post(
        `${consts.BackendUrl}/admin/dashboardCounts`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      setDashboardData(data?.result);

    } catch (error) {
      if (error.response) {
        console.error("Server Error:", error.response.data);
        if (error.response.status === 401) {
          console.warn("Unauthorized! Redirecting to login...");
        }
      } else {
        console.error("Error:", error.message);
      }
    }
  };

  const [withdrawHistorys, setWithdrawHistorys] = useState([]);

  const withdrawHistory = async () => {
    try {
      const token = localStorage.getItem("adminToken");
      if (!token) {
        throw new Error("No authorization token found. Please log in.");
      }

      const { data } = await Axios.get(
        `${consts.BackendUrl}/admin/withdrawList?limit=${limit}&page=${page}&type=Pending`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
            "Content-Type": "application/json",
          },
        }
      );

      console.log(data, "Withdraw Data");

      if (data?.success == true) {
        setWithdrawHistorys(data?.result);
      }
    } catch (error) {
      console.log(error, "error");
    }
  };


  const [tickets, setTickets] = useState([]);

  const supportTicket = async () => {
    try {
      const token = localStorage.getItem("adminToken");
      if (!token) {
        throw new Error("No authorization token found. Please log in.");
      }

      const { data } = await Axios.post(
        `${consts.BackendUrl}/admin/getSupportMsg`,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
            "Content-Type": "application/json",
          },
        }
      );

      console.log(data, "Support_ticket");

      if (data?.success == true) {
        setTickets(data?.result);
      }
    } catch (error) {
      console.log(error, "error");
    }

  }

  console.log(page, "page");
  useEffect(() => {
    // getUsers();
    withdrawHistory();
    dashboardCount();
    supportTicket()
  }, [page, limit]);

  return (
    <div className="Dashboard" style={{ backgroundColor: "#10212C" }}>
      <Box sx={{ display: lg ? "flex" : "block" }}>
        <Header />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 2,
            width: { lg: `calc(100% - ${drawerWidth}px)` },
            marginTop: "50px",
          }}
        >
          {" "}
          <Grid2 container spacing={2}>
            <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 3, xl: 3 }}>
              <div
                className="card"
                style={{ marginBottom: "40px", padding: "10px" }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <p
                    style={{
                      marginTop: "-10px",
                      marginBottom: "-5px",
                      fontSize: "20px",
                      fontWeight: "700",
                    }}
                  >
                    {dashboardData?.completedTrade}
                  </p>{" "}
                  <SyncAltIcon sx={{ marginTop: "20px" }} />
                </div>
                <p className="title-text" style={{ margin: 0 }}>
                  Completed Trade
                </p>
              </div>
            </Grid2>
            <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 3, xl: 3 }}>
              <div className="card" style={{ padding: "10px" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <p
                    style={{
                      marginTop: "-10px",
                      marginBottom: "-5px",
                      fontSize: "20px",
                      fontWeight: "700",
                    }}
                  >
                    {dashboardData?.pending_buy
                      ? dashboardData?.pending_buy
                      : 0}
                  </p>{" "}
                  <ShoppingCartIcon sx={{ marginTop: "20px" }} />
                </div>
                <p className="title-text" style={{ margin: 0 }}>
                  Pending Buy Trade
                </p>
              </div>
            </Grid2>
            <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 3, xl: 3 }}>
              <div className="card" style={{ padding: "10px" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <p
                    style={{
                      marginTop: "-10px",
                      marginBottom: "-5px",
                      fontSize: "20px",
                      fontWeight: "700",
                    }}
                  >
                    {dashboardData?.supportTicket
                      ? dashboardData?.supportTicket
                      : 0}
                  </p>

                  <LocalMallIcon sx={{ marginTop: "20px" }} />
                </div>

                <p className="title-text" style={{ margin: 0 }}>
                  Pending Sell Trade
                </p>
              </div>
            </Grid2>
            <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 3, xl: 3 }}>
              <div className="card" style={{ padding: "10px" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <p
                    style={{
                      marginTop: "-10px",
                      marginBottom: "-5px",
                      fontSize: "20px",
                      fontWeight: "700",
                    }}
                  >
                    {dashboardData?.pending_sell
                      ? dashboardData?.pending_sell
                      : 0}
                  </p>{" "}
                  <LocalActivityIcon sx={{ marginTop: "20px" }} />
                </div>

                <p className="title-text" style={{ margin: 0 }}>
                  Unread Support Tickets
                </p>
              </div>
            </Grid2>
            <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
            <Grid container spacing={3}>
              {/* First table: Recent KYC Submit Users */}
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                sx={{ paddingLeft: "30px", width: "100%" }}
                className="recent-kyc"
              >
                <Paper className="info-card">
                  <Typography
                    variant="h6"
                    sx={{
                      // color: "#fff",
                      borderBottom: "1px solid gray",
                      padding: "10px 0",
                    }}
                  >
                  KYC Pending Users List
                  </Typography>
                  <TableContainer
                    style={{
                      maxHeight: "300px",
                      overflowY: "auto",
                      overflowX: "auto",
                    }}
                  >
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell
                          >
                            Date & Time
                          </TableCell>
                          <TableCell
                          >
                            User Name
                          </TableCell>
                          <TableCell
                          >
                            Kyc Verify
                          </TableCell>
                          <TableCell
                          >Action</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {Array.isArray(kycCount) && kycCount.length > 0 ? (
                          kycCount?.map((item) => (
                            <TableRow
                              key={item?.id || item?._id || Math.random()}
                            >
                              <TableCell >
                                {item?.createdAt
                                  ? new Date(item.createdAt).toLocaleString()
                                  : "N/A"}
                              </TableCell>
                              <TableCell >
                                {item?.first_name} {item?.last_name}
                              </TableCell>
                              <TableCell >
                                Awaiting Confirmation
                              </TableCell>
                              <TableCell>
                                <Button
                                  variant="contained"
                                  sx={{
                                    background: "#fe7701",
                                    fontWeight: "500",
                                    // color: "white",
                                    ":hover": {
                                      backgroundColor: "white",
                                      color: "#fe7701",
                                    },
                                  }}
                                  onClick={() => {
                                    navigate(`/${consts?.route + '/kycdetails'}`, { state: item });
                                  }}
                                >
                                  <EditIcon
                                    sx={{ fontSize: "20px", paddingRight: "5px" }}
                                  />{" "}
                                  View
                                </Button>
                              </TableCell>
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell
                              colSpan={4}
                              sx={{ textAlign: "center", color: "gray" }}
                            >
                              No KYC records found.
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Paper>
              </Grid>

              {/* Second table: User Details */}
              <Grid item xs={12} md={6} lg={6} sx={{ paddingRight: "30px" }}>
                <Paper className="info-card">
                  <Typography
                    variant="h6"
                    sx={{
                      // color: "#fff",
                      borderBottom: "1px solid gray",
                      padding: "10px 0",
                    }}
                  >
                    User Details
                  </Typography>
                  <Typography
                    sx={{
                      // color: "#fff",
                      borderBottom: "1px solid gray",
                      padding: "10px 0",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginLeft: "10px"
                      }}
                    >
                      <p>Total Users</p>

                      <div>
                        <SupervisorAccountIcon sx={{ marginTop: "25px" }} />
                      </div>
                    </div>
                    <p
                      style={{
                        marginTop: "-20px",
                        marginBottom: "-5px",
                        fontSize: "20px",
                        fontWeight: "800",
                        marginLeft: "10px"
                      }}
                    >
                      {dashboardData?.usersCount
                        ? dashboardData?.usersCount
                        : 0}
                    </p>
                  </Typography>
                  <Typography
                  // sx={{ color: "white" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginLeft: "10px"

                      }}
                    >
                      <p>KYC Verified Users</p>

                      <div>
                        <BeenhereIcon sx={{ marginTop: "30px" }} />
                      </div>
                    </div>
                    <p
                      style={{
                        marginTop: "-20px",
                        marginBottom: "-10px",
                        fontSize: "20px",
                        fontWeight: "800",
                        marginLeft: "10px"
                      }}
                    >
                      {dashboardData?.kycusersCount
                        ? dashboardData?.kycusersCount
                        : 0}
                    </p>
                  </Typography>
                </Paper>
              </Grid>

              {/* 
            <div className="custom_table" style={{ color: "white" }}> */}

              {/* Third table: Recent Support Tickets (Left) */}
              <Grid
                item
                xs={12}
                md={6} lg={6}
                sx={{ paddingLeft: "30px" }}
                className="recent-coin"
              >
                <Paper className="info-card">
                  <Typography
                    variant="h6"
                    sx={{
                      // color: "white",
                      borderBottom: "1px solid gray",
                      padding: "10px 0",
                    }}
                  >
                 Pending Coin Withdrawal Requests
                  </Typography>
                  <TableContainer
                    style={{
                      maxHeight: "300px",
                      overflow: "auto",
                    }}

                  >
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell
                          // sx={{ color: "#fff", whiteSpace: "nowrap" }}
                          >
                            Date & Time
                          </TableCell>
                          <TableCell
                          // sx={{ color: "#fff", whiteSpace: "nowrap" }}
                          >
                            User Name
                          </TableCell>
                          <TableCell
                          // sx={{ color: "#fff" }}
                          >
                            Coin/Token
                          </TableCell>
                          <TableCell
                          // sx={{ color: "#fff" }}
                          >Amount</TableCell>
                          <TableCell
                          // sx={{ color: "white", whiteSpace: "nowrap" }}
                          >
                            Withdraw Fee
                          </TableCell>
                          <TableCell
                          // sx={{ color: "white" }}
                          >Status</TableCell>
                          <TableCell
                          //  sx={{ color: "white" }}
                          >Action</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableCell>No Data Found</TableCell>

                      </TableBody>
                    
                    </Table>
                  </TableContainer>
                </Paper>
              </Grid>

              {/* Fourth table: Recent Coin Withdraw Request (Right) */}

              <Grid item xs={12} md={6} lg={6} sx={{ paddingRight: "30px" }}>
                <Paper className="info-card">
                  <Typography
                    variant="h6"
                    sx={{
                      borderBottom: "1px solid gray",
                      padding: "10px 0",
                    }}
                  >
                    Recent Support Tickets
                  </Typography>
                  <TableContainer
                    style={{
                      maxHeight: "300px",
                      overflow: "auto",
                    }}
                    sx={{
                      "&::-webkit-scrollbar": {
                        width: "6px",
                      },
                    }}
                  >
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>Date & Time</TableCell>
                          <TableCell>User Name</TableCell>
                          <TableCell>Ticket ID</TableCell>
                          <TableCell>Subject</TableCell>
                          <TableCell>Message</TableCell>
                          <TableCell>Action</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {tickets.length > 0 ? (
                          tickets.map((ticket) => (
                            <TableRow key={ticket._id}>
                              <TableCell>{new Date(ticket.createdAt).toLocaleString()}</TableCell>
                              <TableCell>{ticket.from}</TableCell>
                              <TableCell>{ticket._id}</TableCell>
                              <TableCell>{ticket.Title}</TableCell>
                              <TableCell>
                                {ticket.Message.length > 0 ? ticket.Message[ticket.Message.length - 1].msg : "No Messages"}
                              </TableCell>
                              <TableCell>
                                <Button
                                  sx={{
                                    background: "#fe7701",
                                    fontWeight: "500",
                                    ":hover": {
                                      
                                      color: "#fff",
                                    },
                                  }}
                                  variant="contained"
                                  onClick={() => navigate("/support")}
                                >
                                  <EditIcon sx={{ fontSize: "20px", paddingRight: "5px" }} /> View
                                </Button>
                              </TableCell>
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell colSpan={6} align="center">No Data Found</TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Paper>
              </Grid>

              {/* </div> */}
            </Grid>
          </Grid2>
          </Grid2>

        </Box>
      </Box>
    </div >
  );
};

export default Dashboard;
